<div
  class="search-component-container"
  [ngClass]="{ 'no-label': suppressLabel }"
  >
  @if (!suppressLabel) {
    <section class="search-label-container">
      @if (searchLabel) {
        <span
          class="search-field-label"
            [ngClass]="{
                'search-field-label-white': searchLabelWhite,
                'search-field-label-black': !searchLabelWhite
            }"
          >
          {{ searchLabel }}
        </span>
      }
      @if (!searchLabel) {
        <span
          class="search-field-label search-field-label-black"
          >
          Filter
        </span>
      }
      <div class="search-field-label-underline"></div>
      @if (searchLabelQualifier) {
        <div [ngClass]="searchLabelQualifierClass">
          {{ searchLabelQualifier }}
        </div>
      }
    </section>
  }
  <section
    class="search-field-container"
        [ngStyle]="{
            background: background,
            'max-width: 420px': true,
            width: searchWidth
        }"
        [ngClass]="{
            'search-field-container-student': isStudent,
            'search-field-container-teacher': !isStudent
        }"
    >
    <div class="search-field-inputs">
      <input
        #searchBox="ngModel"
        name="searchInput"
        matInput
        class="filterPlaceholder"
        (keyup)="applySearchFilter($event.target.value)"
        [(ngModel)]="apiSearchString"
        placeholder="{{ placeholder }}"
        aria-label="Search"
        [disabled]="loading"
        />
    </div>
    @if (apiSearchString) {
      <mat-icon
        matPrefix
        aria-label="Clear"
        class="searchIcon cursor-pointer"
        (click)="clearSearchFilter()"
        >close</mat-icon
        >
      }
      @if (!apiSearchString) {
        <mat-icon
          matPrefix
          aria-label="Search"
          class="searchIcon"
          >
          search
        </mat-icon>
      }
    </section>
  </div>
